import { labelAddSourceFor } from "_constants";

export const FooterDetailSource = ({
  sourceAddedBy,
}: {
  sourceAddedBy?: string;
}) => {
  return (
    <div className="flex-container gap-4">
      <span className="text-base-regular">{labelAddSourceFor}</span>
      <span className="text-base-regular-semibold capitalize">
        {sourceAddedBy ?? ""}
      </span>
    </div>
  );
};
